import React from 'react';
import {
  textSchema,
  textUI,
  titleUI,
  yesNoSchema,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';

export const LimitedConsentDescription = () => (
  <>
    <p>
      You can limit your consent for VA to retrieve only specific information
      from these healthcare providers.
    </p>
    <p>
      Your doctor will follow the limitation you specify. Limiting consent could
      add to the time it takes to get your records.
    </p>
  </>
);

export default {
  // TODO: add a page-level 'ui:confirmationField' once the submission copy exists; ChapterSectionCollection ignores hideOnReview.
  uiSchema: {
    ...titleUI(
      'Limit what information we can request',
      LimitedConsentDescription,
    ),
    'view:limitedConsent': yesNoUI({
      title:
        'Do you want to limit your consent for VA to retrieve only specific information from your other healthcare providers?',
    }),
    limitedConsent: textUI({
      title:
        'If you selected “Yes,” describe what you want to limit (treatment dates, condition type, etc.).',
      required: formData => formData?.['view:limitedConsent'] === true,
      errorMessages: {
        required:
          'Describe how you want to limit VA’s access to your medical records',
      },
      // Keep in sync with dropStaleLimitedConsent, which only submits the text on "Yes".
      hideOnReview: formData => formData?.['view:limitedConsent'] !== true,
    }),
  },
  schema: {
    type: 'object',
    required: ['view:limitedConsent'],
    properties: {
      'view:limitedConsent': yesNoSchema,
      limitedConsent: textSchema,
    },
  },
};
